import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NoResults = ({ colCount }) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <tr className="w-100 text-center">
      <td colSpan={colCount} className="no-results-td text-light">
        {t('noResults')}
      </td>
    </tr>
  );
};

NoResults.propTypes = {
  colCount: PropTypes.number,
};

export default NoResults;
